import { useEffect } from "react";

export default function PageTitle(title) {
  useEffect(() => {
    document.title = `Genomic Life - ${title}`;
  }, [title]);

  return;
}
